import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Header from "./../include/Header";
import Apihelpers from './../helper/ApiHelper';
import MasterServicesCreate from './MasterServicesCreate';
import MasterServicesEdit from './MasterServicesEdit';
import {GET_MASTER_SERVICE_LIST, MASTER_SERVICE_CAT } from './../helper/Constants';


class MasterServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      lastSequence:0,
      editRecord:{
        id:"",
        sr:0,
        key:"",
        name:"",
        cat:"",
        useType:"",
        source:"",
        desc:"",
        doc:"",
        docNew:""
      },
      editPopUp: false,
      loader: false,
      filters:{
        page:0,
        limit:10,
        totalCount:0
      },
      listData:[],
      allPlans:[]
    }
    this.togglePopUp = this.togglePopUp.bind(this);
    this.loadPlanes = this.loadPlanes.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
    this.editTogglePopup = this.editTogglePopup.bind(this);
  }

  togglePopUp() {
    //console.log('call popup toggle');
    this.setState(state => ({
      showPopUp: !state.showPopUp
    }));
  }
  editTogglePopup() {
    this.setState({editPopUp: !this.state.editPopUp})
  }
  toggleLoader(){
    //console.log('call load fun...');
    this.setState({loader: ! this.state.loader });
  }

  componentDidMount() {
    this.loadPlanes();
  }


  loadPlanes = () => {
    let parmes = '?limit='+this.state.filters.limit+'&skip='+(this.state.filters.limit * this.state.filters.page);
    this.setState({loader: true });
    Apihelpers.getdataresponse(GET_MASTER_SERVICE_LIST+parmes).then(res => {
      //console.log('res.data',res.data);
      if (res.data.status === true) {
        let data = res.data.data;
        //console.log('aaaaaaaaaaaaa',data.totalCount);
        this.setState({
          filters:{...this.state.filters, totalCount:data.totalCount},
          listData:data.record,
          lastSequence:(data.lastSequence+1),
          allPlans:data.allPlans
        })
        this.toggleLoader();
      }
    });
  }

  loadPage = (e) => {
    let start = Number(e.target.getAttribute("data-i"));
    this.setState({
      filters: {...this.state.filters, page: start}
    });
    setTimeout(()=>{
      this.loadPlanes();
    },100);
  }
  changeLimit = (e) => {
    let limit = Number(e.target.value);
    this.setState({
      filters: {
        page:0,
        limit:limit,
        totalCount:0
      }
    });
    setTimeout(()=>{
      this.loadPlanes();
    },100);
  }

  render() {
    const renderPaging = () => {
      let pages = (this.state.filters.totalCount / this.state.filters.limit);
      //console.log('pages',pages);
      let pagingHmtl = [];
      for (var i = 0; pages > i; i++ ) {
        pagingHmtl.push(<span key={i} data-i={i} className={(this.state.filters.page == i) ? 'btn active' : 'btn'} onClick={(e)=>{this.loadPage(e)}}>{i+1}</span>);
      }
      return pagingHmtl;
    }
    return (
      <div className="wrapper serviceProvider">
        <Header />
        <div className="container">
          <div className="whiteBox">
            {
              //JSON.stringify(this.state.filters,null,2)
            }
            <div className="titleRow">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="title">Service Plan list</h3>
                  <span className="desc">Showing {this.state.listData.length} out of {this.state.filters.totalCount}</span>
                </div>
                <div className="col-auto">
                  <a href="#" onClick={this.togglePopUp}>Add new plan</a>
                </div>
              </div>
            </div>
            <div className="tableBorder">
              <table className="table">
                <thead>
                  <tr>
                    <th style={{width:'200px'}}>Sequence No. & key</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Use Type</th>
                    <th>Doc</th>
                    <th>Source</th>
                    <th>Dependency Plan</th>
                    <th style={{width:'80px'}}>User Count</th>
                    <th style={{width:'110px'}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.listData.length > 0 ?
                      this.state.listData.map((item)=>{
                        let cat = '--';
                        //MASTER_SERVICE_CAT
                        if(item?.service_category){
                          let catObj = MASTER_SERVICE_CAT.filter((obj)=>(obj.slug === item?.service_category));
                          cat = catObj[0]?.label;
                        }
                        let source = '--';
                        if (item.service_source === 'free') {
                          source = 'Free';
                        } else if (item.service_source === 'paid') {
                          source = 'Paid';
                        }
                        let type = '--';
                        if (item.service_use_type === 'api') {
                          type = 'API';
                        } else if (item.service_use_type === 'panel') {
                          type = 'Panel';
                        }
                        let parentPlan = [];
                        if (item.traversing_dependency === 'child') {
                          let partItms = item.parent_id;
                          if(partItms.length > 0) {
                            partItms.forEach(ele => {
                              let parItm = this.state.allPlans.filter((it)=>(it._id === ele));
                              parentPlan.push(parItm[0]?.serviceName);
                              //console.log('parItm',parItm[0]);
                            });
                          }
                        }
                        //this.state.listData
                        return(
                          <tr key={item._id}>
                            <td><strong className="cr">{item.service_sequence}</strong> <span>{item.serviceName}</span></td>
                            <td><span className="tt">{(item.service_name === '') ? '--' : (item.service_name === undefined) ? '--' : item.service_name}</span></td>
                            <td>{cat}</td>
                            <td>{type}</td>
                            <td>
                              {
                                (item.service_document !== '' && item.service_document !== undefined) ?
                                <a className="btn-icon light" target="_blank" href={`${Apihelpers.getBaseUrl()+'api_documents/'+item.service_document}`} title="View Document"><i className="fa fa-file-text-o"></i></a>
                                :
                                "--"
                              }
                            </td>
                            <td>{source}</td>
                            <td>
                              {
                                parentPlan.map((ite)=>{
                                  return(<span className="planName" key={ite}>{ite}</span>)
                                })
                              }
                            </td>
                            <td><a className="countLink" href={"/admin/client-list?loginStatus=login-active&tokenStatus=all&plan="+item.serviceName}>{item.userCount}</a></td>
                            <td>
                              <button className="btn-icon" onClick={()=>{
                                this.setState({
                                  editRecord: {
                                    id:item._id,
                                    showPopUp: true,
                                    sr:item.service_sequence,
                                    key:item.serviceName,
                                    name:item.service_name,
                                    cat:item.service_category || "rcInfo",
                                    useType:item.service_use_type || "api",
                                    source:item.service_source || "free",
                                    srUrl:item.service_url || "",
                                    desc:item.service_desc || "",
                                    doc:item.service_document,
                                    docNew:"",
                                    traDep:item.traversing_dependency || "parent",
                                    parent_id:item.parent_id,
                                  },
                                  editPopUp: true,
                                  allPlans:this.state.allPlans
                                })
                              }} title="Edit Plan"><i className="fa fa-pencil-square-o"></i></button>
                              {/* <button className="btn-icon"><i className="fa fa-eye"></i></button> */}
                            </td>
                          </tr>
                        )
                      })
                    :
                    <tr>
                      <td colSpan="8">Record Not Found...</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div className="row">
              <div className="col">
                <div className="pageing">
                  {/* <span className="btn active">1</span>
                  <span className="btn">2</span>
                  <span className="btn">3</span>
                  <span className="btn">4</span> */}
                  {renderPaging()}
                </div>
              </div>
              <div className="col-auto">
                <select className="form-control" onChange={this.changeLimit} defaultValue={this.state.filters.limit}>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {
          this.state.showPopUp ?
          <MasterServicesCreate lastSequence={this.state.lastSequence} togglePopUp={this.togglePopUp} loadPlanes={this.loadPlanes} allPlans={this.state.allPlans} toggleLoader={this.toggleLoader} />
          :""
        }

        {
          this.state.editPopUp ?
            <MasterServicesEdit editTogglePopup={this.editTogglePopup} loadPlanes={this.loadPlanes} toggleLoader={this.toggleLoader} allPlans={this.state.allPlans} editRecord={this.state.editRecord} />
          :""
        }
        

        <div className="loader" style={{ display: `${this.state.loader ? 'block' : 'none'}`, zIndex:'111'}}>
          <div className="bg" />
          <img className="loadingImg" src="/assets/images/loading.gif"  alt="" />
        </div>
      </div>
    )
  }
}

export default MasterServices;